var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useRef } from 'react';
import { ProjectAvatar } from './ProjectAvatar';
import ReactTimeAgo from 'react-time-ago';
import useOutsideClick from '../../shared-components/useOutsideClick';
import { IconContainerBig } from "../../Styles/SharedStyledComponents";
export var ProjectHeader = function (_a) {
    var author = _a.author, date = _a.date, company = _a.company;
    // eslint-disable-next-line no-unused-vars
    var _b = __read(React.useState(''), 2), controllersTooltip = _b[0], setControllersTooltip = _b[1];
    var tooltipRef = useRef(null);
    useOutsideClick(tooltipRef, function () {
        setControllersTooltip('');
    });
    return (_jsxs(_Fragment, { children: [_jsxs("div", { className: "post-header", children: [_jsxs("div", { className: "post-header-unit-top", children: [_jsx(ProjectAvatar, { author: author }), _jsx("div", { className: "post-header-top", children: _jsx("p", { className: "auth-name", children: author }) })] }), _jsx("div", { className: "post-header-unit-top", children: (company === null || company === void 0 ? void 0 : company.badge) && (_jsx(IconContainerBig, { children: _jsx("img", { src: company.badge, alt: company.type_company ? company.type_company : "company badge" }) })) })] }), _jsx("p", { className: "time-ago", children: _jsx(ReactTimeAgo, { date: new Date(date), locale: "en-us", timeStyle: "twitter" }) })] }));
};
